import { observable, action } from 'mobx'

class PrizeChestStore {
  @observable
  prizeChestList = [
    {
      backgroundColor: '#231f20',
      secondaryBackgroundColor: '#efdf18',
      tertiaryBackgroundColor: '#221e1f',
      prizeImage: 'star-category-shows.jpg',
      prizeImageColor: '#221e1f',
      title: 'stars earned',
      subTitle: 'are used for prizes',
      titleColor: '#221e1f',
      subTitleColor: '#221e1f',
      starIcon: 'star-icon-dark.svg',
      score: 2,
      //awardTitle: 'go to star board',
      awardTitle: [{ value: 'go to' }, { value: 'star board' }],
      awardTitleColor: '#efdf18',
      awardIcon: 'prizeboard-icon-prizechest.svg',
      awardIconColor: '#221e1f',
      awardBackgroundColor: '#efdf18',
      awardIconSize: 70,
      type: 'starboard',
      keyword: 'starboard',
    },
    {
      backgroundColor: '#231f20',
      secondaryBackgroundColor: '#ffffff',
      tertiaryBackgroundColor: '#574263',
      prizeImage: 'playalongnow-prizechest-woot.jpg',
      prizeImageColor: '#9368aa',
      title: 'uncover woot!',
      subTitle: 'delivered by amazon prime',
      titleColor: '#9368aa',
      subTitleColor: '#000000',
      starIcon: 'star-icon-dark.svg',
      score: 1,
      awardTitle: [{ value: 'read' }],
      awardIcon: 'read-btn-icon.svg',
      awardIconColor: '#ffffff',
      awardBackgroundColor: '#9368aa',
      keyword: 'woot',
      prizeChest: {
        rank: 1,
        topSmallHeaders: [{ value: 'UNCOVER' }],
        headers: [{ value: 'THE WORLD OF WOOT!' }],
        details: [{ value: 'TECH, GEAR & MORE - DELIVERED BY AMAZON PRIME' }],
        images: ['sponsors/playalongnow-liveplay_progress-woot.jpg'],
      },
    },
    {
      backgroundColor: '#231f20',
      secondaryBackgroundColor: '#ffffff',
      tertiaryBackgroundColor: '#30397a',
      prizeImage: 'playalongnow-bigprizeboards-amalfi_coast.jpg',
      prizeImageColor: '#495bdb',
      title: 'amalfi coast',
      subTitle: 'italian vacation package',
      titleColor: '#495bdb',
      subTitleColor: '#000000',
      starIcon: 'star-icon-dark.svg',
      score: 1,
      awardTitle: [{ value: 'watch' }],
      awardIcon: 'play-btn-icon.svg',
      awardIconColor: '#ffffff',
      awardBackgroundColor: '#495bdb',
      keyword: 'amalfi',
    },
    {
      backgroundColor: '#231f20',
      secondaryBackgroundColor: '#ffffff',
      tertiaryBackgroundColor: '#30397a',
      prizeImage: 'playalongnow-bigprizeboards-small_luxury_hotels.jpg',
      prizeImageColor: '#495bdb',
      title: 'small luxury hotels',
      subTitle: 'of the world - vacation package',
      titleColor: '#495bdb',
      subTitleColor: '#000000',
      starIcon: 'star-icon-dark.svg',
      score: 1,
      awardTitle: [{ value: 'watch' }],
      awardIcon: 'play-btn-icon.svg',
      awardIconColor: '#ffffff',
      awardBackgroundColor: '#495bdb',
      keyword: 'hotel',
    },
    {
      backgroundColor: '#231f20',
      secondaryBackgroundColor: '#ffffff',
      tertiaryBackgroundColor: '#574263',
      prizeImage: 'playalongnow-bigprizeboards-ny_broadway.jpg',
      prizeImageColor: '#9368aa',
      title: 'new york broadway',
      subTitle: 'vacation package',
      titleColor: '#9368aa',
      subTitleColor: '#000000',
      starIcon: 'star-icon-dark.svg',
      score: 1,
      awardTitle: [{ value: 'read' }],
      awardIcon: 'read-btn-icon.svg',
      awardIconColor: '#ffffff',
      awardBackgroundColor: '#9368aa',
      keyword: 'broadway',
    },
    {
      backgroundColor: '#231f20',
      secondaryBackgroundColor: '#ffffff',
      tertiaryBackgroundColor: '#574263',
      prizeImage: 'playalongnow-bigprizeboards-other_prizes.jpg',
      prizeImageColor: '#9368aa',
      title: 'training & gear',
      subTitle: 'SKLZ® EXOS®',
      titleColor: '#9368aa',
      subTitleColor: '#000000',
      starIcon: 'star-icon-dark.svg',
      score: 1,
      awardTitle: [{ value: 'read' }],
      awardIcon: 'read-btn-icon.svg',
      awardIconColor: '#ffffff',
      awardBackgroundColor: '#9368aa',
      keyword: 'gear',
    },
    // {
    //   backgroundColor: '#231f20',
    //   secondaryBackgroundColor: '#808285',
    //   tertiaryBackgroundColor: '#3f3f3f',
    //   prizeImage: 'playalongnow-bigprizeboards-ny_broadway.jpg',
    //   prizeImageColor: '#221e1f',
    //   title: 'ny - broadway',
    //   subTitle: 'vacation package',
    //   titleColor: 'rgba(255,255,255, 0.8)',
    //   subTitleColor: 'rgba(255,255,255, 0.8)',
    //   starIcon: 'star-icon-dark.svg',
    //   score: 4,
    //   awardTitle: [{ value: 'read' }],
    //   awardIcon: 'menu-prizes_open-icon-white.svg',
    //   awardIconColor: '#ffffff',
    //   awardBackgroundColor: '#c61818',
    //   awardIconSize: 70,
    //   isUsed: false,
    //   keyword: 'broadway',
    // },
  ]
}

export default new PrizeChestStore()



// WEBPACK FOOTER //
// src/stores/PrizeChestStore.js